import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { compact, forEach, get, set, split, unset } from 'lodash';
import { ViewportScroller } from '@angular/common';
import { ProposalPermission } from '@lockton-apps/shared/interfaces';

interface PanelWrapperComponentProps extends FormlyFieldProps {
  id: string;
  index: string;
  className: string;
  notes: string;
  tooltip: { text: string };
  icon: string;
  iconColor: string;
  iconBackgroundColor: string;
  permissions?: Record<string, ProposalPermission>;
}

type PanelConfig = FormlyFieldConfig<PanelWrapperComponentProps>;

@Component({
    selector: 'lockton-apps-panel-wrapper',
    templateUrl: './panel-wrapper.component.html',
    styleUrls: ['./panel-wrapper.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PanelWrapperComponent
  extends FieldWrapper<PanelConfig>
  implements OnInit
{
  @ViewChild('container', { static: true }) _container!: ElementRef;

  readonly addonsFields: FormlyFieldConfig[] = [
    {
      type: 'textarea',
      key: 'notes',
      props: {
        label: 'Please include any extra notes',
      },
    },
  ];
  showNotes!: boolean;

  constructor(
    private readonly renderer: Renderer2,
    private readonly scroller: ViewportScroller
  ) {
    super();
  }

  ngOnInit(): void {
    this.addonsFields[0].defaultValue = get(
      this.model,
      `${this.props.id}.notes`,
      ''
    );
    this.showNotes = !!this.addonsFields[0].defaultValue;

    this.applyClasses();
  }

  onModelChange({ notes }: any): void {
    set(this.model, `${this.props.id}.notes`, notes);
    this.form.markAsDirty();
  }

  toggleNotes(showNotes: boolean): void {
    const scrollTarget: string = showNotes
      ? `section-${this.props.id}__notes`
      : `section-${this.props.id}`;

    this.showNotes = showNotes;
    this.scroller.setOffset([0, 25]);
    this.scroller.scrollToAnchor(scrollTarget);

    if (!this.showNotes) {
      unset(this.model, `${this.props.id}.notes`);
    }
  }

  private applyClasses(): void {
    const baseClasses: string =
      'panel-wrapper px-2_5 py-4 pt-sm-6 mw-lg mx-auto';

    this.renderer.removeAttribute(this._container.nativeElement, 'class');

    forEach(
      compact(split(`${baseClasses} ${this.props.className}`, ' ')),
      (className) => {
        this.renderer.addClass(this._container.nativeElement, className);
      }
    );
  }
}
